import formatStat, { renderStat } from '@utils/formatStat'
import capitalize from '@utils/capitalize'
import { size } from '@styles/theme'

import { DialogFormGroup, Section, SectionHeading } from './SharedFormComponents'
import { SingleEnumRadio } from '@elements/form_elements/SingleEnumRadio'
import { DialogInput } from '@elements/dialog_inputs/DialogInput'

const inchLabelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(10),
  marginRight: size(-5),
}

const unspecifiedLabelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(15),
  marginRight: size(-4),
}

const AgeRadioList = ({ state, handleExtendedChange }) => {
  let radioList = []
  for (let i = 18; i <= 100; i++) {
    radioList.push(
      <SingleEnumRadio
        onChange={handleExtendedChange}
        state={state}
        name='age'
        label={`${i}`}
        value={`${i}`}
        key={i}
      />
    )
  }
  return <DialogFormGroup>{radioList}</DialogFormGroup>
}

const HeightRadioList = ({ state, handleExtendedChange }) => {
  let radioList = []
  let radioSet = new Set()
  let formatted

  for (let i = 105; i <= 214; i++) {
    formatted = formatStat('height', i)
    if (radioSet.has(formatted)) continue;
    else {
      radioSet.add(formatted)
      radioList.push(
        <SingleEnumRadio
          slots={{ label: { style: inchLabelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='height'
          label={`${formatted}`}
          value={`${i}`}
          key={i}
        />
      )
    }
  }
  return <DialogFormGroup>{radioList}</DialogFormGroup>
}

const WeightRadioList = ({ state, handleExtendedChange }) => {
  let radioList = []
  for (let i = 100; i <= 350; i+= 5) {
    radioList.push(
      <SingleEnumRadio
        onChange={handleExtendedChange}
        state={state}
        name='weight'
        label={`${i} lbs${i === 350 ? ' +' : ''}`}
        value={`${i/2.2}`}
        key={i}
      />
    )
  }
  return <DialogFormGroup>{radioList}</DialogFormGroup>
}

const EndowmentSizeRadioList = ({ state, handleExtendedChange }) => {
  let radioList = []
  for (let i = 0; i <= 15; i+= 0.5) {
    radioList.push(
      <SingleEnumRadio
        slots={{ label: { style: inchLabelStyles } }}
        onChange={handleExtendedChange}
        state={state}
        name='endowmentSize'
        label={`${i}"`}
        value={`${i*2.54}`}
        key={i}
      />
    )
  }
  return <DialogFormGroup>{radioList}</DialogFormGroup>
}

const EndowmentCutRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['endowment_cut_unspecified', 'cut', 'uncut']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: unspecifiedLabelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='endowmentCut'
          label={capitalize(formatStat('endowmentCut', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const BodyTypeRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['body_type_unspecified', 'slim', 'fit', 'muscular', 'body_type_average', 'stocky', 'chubby', 'large']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: unspecifiedLabelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='bodyType'
          label={capitalize(formatStat('bodyType', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const StatsFormSection = ({ state, handleExtendedChange, handleClear }) => {
  return (
    <Section style={{ paddingTop: size(1) }}>
      <SectionHeading>
        Your Stats
      </SectionHeading>
      <DialogInput
        label='Age'
        onClear={() => handleClear('age', '')}
        displayValue={state['age'] && renderStat('age', state)}>
        <AgeRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
      <DialogInput
        label='Height'
        onClear={() => handleClear('height', '')}
        displayValue={state['height'] && renderStat('height', state)}>
        <HeightRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
      <DialogInput
        label='Weight'
        onClear={() => handleClear('weight', '')}
        displayValue={state['weight'] && renderStat('weight', state)}>
        <WeightRadioList state={state} handleExtendedChange={handleExtendedChange}  />
      </DialogInput>
      <DialogInput
        label='🍆 Size'
        onClear={() => handleClear('endowmentSize', '')}
        displayValue={state['endowmentSize'] && renderStat('endowmentSize', state)}>
        <EndowmentSizeRadioList state={state} handleExtendedChange={handleExtendedChange}  />
      </DialogInput>
      <DialogInput
        label='🍆 Cut/Uncut'
        onClear={() => handleClear('endowmentCut', 'endowment_cut_unspecified')}
        displayValue={state['endowmentCut'] && renderStat('endowmentCut', state)}>
        <EndowmentCutRadioList state={state} handleExtendedChange={handleExtendedChange}  />
      </DialogInput>
      <DialogInput
        label='Body Type'
        onClear={() => handleClear('bodyType', 'body_type_unspecified')}
        displayValue={state['bodyType'] && renderStat('bodyType', state)}>
        <BodyTypeRadioList state={state} handleExtendedChange={handleExtendedChange}  />
      </DialogInput>
    </Section>
  )
}

export { StatsFormSection }
